import React, { useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
// import './Work.scss';

const Work = () => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
    
      <h2 className="text-4xl font-extrabold text-center text-blue-600 ">Portfolio<span className='text-blue-400'> Collection</span></h2>

      <div className="border-dashed flex flex-row flex-wrap items-center justify-start mx-0 mb-8 mt-16">
        {['Data cleaning', 'Exploratory data analysis EDA', 'Data visualization', 'Web scraping', 'All'].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`p-2 mr-12 rounded-full bg-white font-bold cursor-pointer ease-in m-2 hover:bg-blue-500 hover:text-white  text-black  xl:p-3 xl:rounded-xl flex justify-center items-center  text-xs text-left leading-6  ${activeFilter === item ? 'item-active bg-blue-500 text-white hover:bg-slate-500 rounded-full'  : ''}`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className=" xl:grid xl:grid-cols-3 xl:gap-4 lg:grid lg:grid-cols-2 lg:gap-4 md:grid md:grid-cols-2 md:gap-2 sm:grid   "
      >
        {filterWork.map((work, index) => (
          <div 
   
          className=" bg-white xl:w-80 w-60 rounded-lg hover:shadow-xl cursor-pointer  m-8 p-4 text-black lg:w-72 md:w-72  "
           key={index}>
            <div
              className=" h-56 relative w-full flex items-center justify-center"
            >
              <img src={urlFor(work.imgUrl)} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className=" bg-gradient-to-r from-gray-600 rounded-lg h-full opacity-0  absolute inset-0 w-full ease-in  flex items-center justify-center"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">

                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="bg-indigo-100 cursor-pointer rounded-full font-extrabold h-10 m-4 text-blue-700 w-10  flex items-center justify-center hover:scale-125"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="bg-indigo-100 cursor-pointer rounded-full font-extrabold h-10 m-4 text-blue-800 w-10   flex items-center justify-center  hover:scale-125"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="flex-col p-2 relative w-full flex items-center justify-center">
              <h4 className="leading-normal  mt-12 xl:mt-12">{work.title}</h4>
              <p className="text-gray-600  text-xs leading-normal text-left md:text-base" style={{ marginTop: 10 }}>{work.description}</p>

              <div className="bg-white py-2 px-4 absolute rounded-lg top-5 flex items-center justify-center">
                <p className="text-xs leading-normal text-center text-gray-400 md:text-base ">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work,'flex-col flex-grow w-full'),
  'work',
  'bg-blue-200',
);